module.exports = __webpack_public_path__ + "img/calendar2-day.948df9ef.svg";